__turbopack_context__.v({
  "button": "Newsletter-module__VckbQW__button",
  "container": "Newsletter-module__VckbQW__container",
  "form": "Newsletter-module__VckbQW__form",
  "input": "Newsletter-module__VckbQW__input",
  "section": "Newsletter-module__VckbQW__section",
  "slideIn": "Newsletter-module__VckbQW__slideIn",
  "subtitle": "Newsletter-module__VckbQW__subtitle",
  "success": "Newsletter-module__VckbQW__success",
  "title": "Newsletter-module__VckbQW__title",
});
